import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../assets/images/State-Distributor/logo.png";
import { LuLayoutDashboard } from "react-icons/lu";
import { FaCartFlatbed } from "react-icons/fa6";
import { IoTvOutline } from "react-icons/io5";
import { IoCubeOutline } from "react-icons/io5";
import { IoPeopleOutline } from "react-icons/io5";
import { TbReportMoney } from "react-icons/tb";
import { LuNotepadText } from "react-icons/lu";
import { FiSettings } from "react-icons/fi";
import { TbLogout } from "react-icons/tb";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import { IoMdImages } from "react-icons/io";
import { FaNetworkWired } from "react-icons/fa";

export const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;

  // logout modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [activeMenu, setActiveMenu] = useState(pathName || "/dashboard");
  useEffect(() => {
    setActiveMenu(pathName);
  }, [pathName]);

  async function handleLogout() {
    try {
      const response = await axiosInstance.post("/logout");
      if (response.data.status === "success" || response.status === 200) {
        sessionStorage.clear();
        navigate("/signin");
      }
    } catch (error) {
      toast.error("Unable to logout");
    }
  }
  const userType = sessionStorage.getItem("user_type");
  return (
    <>
      <div
        style={{
          width: window.innerWidth >= 992 ? "250px" : "100vw", // Fixed width on large screens, full width on mobile
          height: "100vh",
          overflow: "auto",
          position: "fixed",
          left: isOpen || window.innerWidth >= 992 ? "0" : "-100vw", // Always visible on large screens
          top: 0,
          transition: "left 0.3s ease-in-out",
          zIndex: 1000, // Ensure it appears above other elements
        }}
        className="sidebar"
      >
        {/* Close Button (Only Visible on Small Screens) */}
        {window.innerWidth < 992 && isOpen && (
          <button
            onClick={toggleSidebar}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            className="close-btn"
          >
            ✖
          </button>
        )}

        <div className="sidebarLogo">
          <img src={logo} />
        </div>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
          }}
        >
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                activeMenu === "/state-dashboard"
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-dashboard" onClick={toggleSidebar}>
                <span className="me-2">
                  <LuLayoutDashboard />
                </span>
                Dashboard
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-dashboard",
                  "/sub-dashboard-viewallsales",
                  "/sub-dashboard-viewSalesInvoice",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-dashboard" onClick={toggleSidebar}>
                <span className="me-2">
                  <LuLayoutDashboard />
                </span>
                Dashboard
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                [
                  "/state-inventory",
                  "/state-inventory-bulkReorder",
                  "/state-inventory-bulkAddIncomeStock",
                  "/state-inventory-view",
                  "/state-edit-refwise-stock",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-inventory" onClick={toggleSidebar}>
                <span className="me-2">
                  <FaCartFlatbed />
                </span>
                Inventory
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-inventory",
                  "/sub-inventory-reorder",
                  "/sub-inventory-addincomestock",
                  "/sub-add-product",
                  "/sub-edit-refwise-stock",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-inventory" onClick={toggleSidebar}>
                <span className="me-2">
                  <FaCartFlatbed />
                </span>
                Inventory
              </Link>
            </li>
          )}

          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                ["/state-catalogue", "/state-view-catalogue"].includes(
                  activeMenu,
                )
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-catalogue" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoMdImages />
                </span>
                Catalogue
              </Link>
            </li>
          ) : (
            <li
              className={
                ["/sub-catalogue", "/sub-view-catalogue"].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-catalogue" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoMdImages />
                </span>
                Catalogue
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                [
                  "/state-sales",
                  "/state-sales-invoice",
                  "/state-sales-products",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-sales" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoTvOutline />
                </span>
                Sales (POS)
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-sales",
                  "/sub-sales-invoice",
                  "/sub-sales-products",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-sales" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoTvOutline />
                </span>
                Sales (POS)
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                [
                  "/state-orders",
                  "/state-orders-manage",
                  // "/state-viewOrders",
                  "/view-order-invoice",
                  "/state-orders-create",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-orders" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoCubeOutline />
                </span>
                Orders
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-orders",
                  "/sub-orders-reorder",
                  "/sub-orders-addIncomeStock",
                  "/sub-create-order",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-orders" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoCubeOutline />
                </span>
                Orders
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                [
                  "/state-invoice",
                  "/state-invoice-viewDistributor",
                  "/state-invoice-manageDistributor",
                  "/state-invoice-viewPos",
                  "/state-invoice-view",
                  "/state-invoice-edit",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-invoice" onClick={toggleSidebar}>
                <span className="me-2">
                  <TbReportMoney />
                </span>
                Invoices
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-invoice",
                  "/sub-invoice-viewDistributor",
                  "/sub-invoice-manageDistributor",
                  "/sub-invoice-viewPos",
                  "/sub-invoice-view",
                  "/sub-invoice-edit",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-invoice" onClick={toggleSidebar}>
                <span className="me-2">
                  <TbReportMoney />
                </span>
                Invoices
              </Link>
            </li>
          )}

          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                ["/state-customer"].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-customer" onClick={toggleSidebar}>
                <span className="me-2">
                  <FaNetworkWired />
                </span>
                Customers
              </Link>
            </li>
          ) : (
            <li
              className={
                ["/sub-customer"].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-customer" onClick={toggleSidebar}>
                <span className="me-2">
                  <FaNetworkWired />
                </span>
                Customers
              </Link>
            </li>
          )}

          {userType === "DISTRIBUTOR" && (
            <li
              className={
                [
                  "/state-sub-distributors",
                  "/state-view-subDistributors",
                  "/state-subdistributors-manage",
                  "/state-subdistributors-viewInvoice",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-sub-distributors" onClick={toggleSidebar}>
                <span className="me-2">
                  <IoPeopleOutline />
                </span>
                Sub-distributors
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" && (
            <li
              className={
                ["/state-paymentDues", "/state-view-paymentsDues"].includes(
                  activeMenu,
                )
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-paymentDues" onClick={toggleSidebar}>
                <span className="me-2">
                  <TbReportMoney />
                </span>
                Payments & Dues
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                [
                  "/state-quotations",
                  "/state-newQuotations",
                  "/state-view-quotations",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-quotations" onClick={toggleSidebar}>
                <span className="me-2">
                  <LuNotepadText />
                </span>
                Quotations
              </Link>
            </li>
          ) : (
            <li
              className={
                [
                  "/sub-quotations",
                  "/sub-newQuotations",
                  "/sub-view-quotations",
                ].includes(activeMenu)
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-quotations" onClick={toggleSidebar}>
                <span className="me-2">
                  <LuNotepadText />
                </span>
                Quotations
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li
              className={
                activeMenu === "/state-settings"
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/state-settings" onClick={toggleSidebar}>
                <span className="me-2">
                  <FiSettings />
                </span>{" "}
                Settings
              </Link>
            </li>
          ) : (
            <li
              className={
                activeMenu === "/sub-settings"
                  ? "sidebarListActive"
                  : "sidebarList"
              }
            >
              <Link to="/sub-settings" onClick={toggleSidebar}>
                <span className="me-2">
                  <FiSettings />
                </span>{" "}
                Settings
              </Link>
            </li>
          )}
          {userType === "DISTRIBUTOR" ? (
            <li className="sidebarList">
              <Link
                // to="/state-dashboard"
                onClick={() => {
                  handleShow();
                  toggleSidebar();
                }}
              >
                <span className="me-2">
                  <TbLogout />
                </span>
                Log out
              </Link>
            </li>
          ) : (
            <li className="sidebarList">
              <Link
                // to="/sub-dashboard"
                onClick={() => {
                  handleShow();
                  toggleSidebar();
                }}
              >
                <span className="me-2">
                  <TbLogout />
                </span>
                Log out
              </Link>
            </li>
          )}
        </ul>
      </div>

      {/* logout modal  */}
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="logoutModal"
        >
          <Modal.Header closeButton>
            <Modal.Title className="logoutTitle">
              Log Out Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="logoutContent">
            You are about to log out of your account.
          </Modal.Body>
          <Modal.Footer>
            <Button className="logoutBtnCancel" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              className="btnLogout"
              onClick={() => {
                handleClose();
                handleLogout();
              }}
            >
              Log Out
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
